import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class NmiPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  apiKey: string;

  constructor(options?: Partial<NmiPaymentProcessorAccountConfiguration>) {
    super(options);
  }
}
